<template>
    <div class="rating-item">
        <div class="w-100 description-item">
            <ckeditor
                v-model="description"
                :editor="editor"
                :config="editorConfig"
                @blur="updateItemDescription()">
            </ckeditor>
        </div>

        <div class="errors">
            <b-alert
                v-if="error.title"
                show
                variant="danger"
                >{{ error.titleMessage }}</b-alert
            >
            <b-alert
                v-if="error.max"
                show
                variant="danger"
                >{{ error.maxMessage }}</b-alert
            >
            <b-alert
                v-if="error.weight"
                show
                variant="danger"
                >{{ error.weightMessage }}</b-alert
            >
        </div>

        <div
            class="max-weight"
            v-if="parseInt(itemIn.type) === 1 && parseInt(sectionIn.type) === 1">
            <div class="input-group weight-group">
                <label for="weight-input-value">Weging</label>
                <div class="input-group-prepend">
                    <div
                        class="input-group-text"
                        id="btnGroupAddon"
                        :class="error.weight && 'bg-danger'"
                        :title="$t('rating.weight')">
                        <i
                            class="fa fa-weight-hanging"
                            v-if="!error.weight"></i>
                        <i
                            class="fal fa-exclamation-circle"
                            v-else></i>
                    </div>
                </div>
                <b-form-input
                    id="weight-input-value"
                    v-model="itemIn.weight"
                    @change="updateItemWeight"></b-form-input>
            </div>

            <div class="input-group max-group">
                <label for="option-input-value">{{ $t('rating.maximum_amount_of_points') }}</label>
                <div class="input-group-prepend">
                    <div
                        class="input-group-text btnGroupAddon"
                        :class="error.max && 'bg-danger'"
                        :title="$t('rating.maximum_amount_of_points')">
                        <i
                            class="fab fa-maxcdn"
                            v-if="!error.max"></i>
                        <i
                            class="fal fa-exclamation-circle"
                            v-else></i>
                    </div>
                </div>
                <b-form-input
                    id="option-input-value"
                    v-model="itemIn.max"
                    @change="updateItemMax"></b-form-input>
            </div>
        </div>

        <div v-if="parseInt(itemIn.type) === 2">
            <design-2021-rating-edit-option-component
                v-for="option in itemIn.options"
                :key="option.id"
                :option="option"
                :section="sectionIn"
                @trigger-error="triggerError"
                @clear-error="clearError">
            </design-2021-rating-edit-option-component>

            <div class="add-option-rating">
                <button
                    class="btn btn-add btn-primary"
                    v-b-modal="'rating-edit-add-option-modal-' + itemIn.id"
                    v-b-tooltip="'Nieuwe keuze'">
                    {{ $t('rating.new_choice') }}
                </button>

                <design-2021-rating-edit-add-option-modal-component
                    :item="itemIn"></design-2021-rating-edit-add-option-modal-component>
            </div>
            <div
                class="item-weight"
                v-if="parseInt(sectionIn.type) === 1">
                <div class="input-group item-weight-group">
                    <label for="weight-input-value">Weging</label>
                    <div class="input-group-prepend">
                        <div
                            class="input-group-text btnGroupAddon"
                            :class="error.weight && 'bg-danger'">
                            <i
                                class="fa fa-weight-hanging"
                                v-if="!error.weight"></i>
                            <i
                                class="fal fa-exclamation-circle"
                                v-else></i>
                        </div>
                    </div>
                    <b-form-input
                        id="weight-input-value"
                        v-model="itemIn.weight"
                        @change="updateItemWeight"></b-form-input>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ApprenticeEditor from '../../helpers/ApprenticeEditor';

export default {
    name: 'design-2021-rating-edit-show-items-component',
    props: ['itemIn', 'sectionIn'],
    data() {
        return {
            description: this.itemIn.description !== null ? this.itemIn.description : '',
            editor: ApprenticeEditor,
            editorConfig: {
                contentsCss: 'test',
                bodyClass: 'mybodyclass',
                toolbar: {
                    items: [
                        'heading',
                        '|',
                        'bold',
                        'italic',
                        'underline',
                        '|',
                        'link',
                        'bulletedList',
                        'numberedList',
                        'undo',
                        'redo',
                    ],
                },
                language: this.$authUser.locale,
                table: {
                    contentToolbar: ['tableColumn', 'tableRow', 'mergeTableCells'],
                },
            },
            weightError: false,
            maxError: false,
            error: {
                title: false,
                titleMessage: this.$t('rating.title_cannot_be_empty'),
                max: false,
                maxMessage: this.$t('rating.maximum_value_cannot_be_empty_it_must_be_a_whole_number'),
                weight: false,
                weightMessage: this.$t('rating.weight_cannot_be_empty_it_must_be_a_valid_comma_number'),
            },
        };
    },
    methods: {
        updateItemDescription() {
            const data = {
                description: this.description,
                id: this.itemIn.id,
            };

            this.axios.post(this.routes.ratingItemDescription(), data).then(
                (response) => {
                    this.itemIn.update({ description: this.description });
                },
                (error) => {
                    this.alert.ajaxError(error);
                },
            );
        },

        updateItemWeight(value) {
            this.error.weight = false;

            let parsedValue = value.replace(/,/g, '.');

            if (parsedValue === '' || isNaN(parseFloat(parsedValue)) || parsedValue.split('.').length >= 4) {
                this.error.weight = true;
                return;
            }

            const data = {
                weight: parseFloat(parsedValue).toFixed(3),
                id: this.itemIn.id,
            };

            this.axios.post(this.routes.ratingItemWeight(), data).then(
                (response) => {
                    this.itemIn.update({ weight: parseFloat(parsedValue).toFixed(3) });
                },
                (error) => {
                    this.alert.ajaxError(error);
                },
            );
        },

        updateItemMax(value) {
            this.error.max = false;

            if (value === '' || isNaN(parseInt(value))) {
                this.error.max = true;
                return;
            }

            const data = {
                max: parseInt(value),
                id: this.itemIn.id,
            };

            this.axios.post(this.routes.ratingItemMax(), data).then(
                (response) => {
                    this.itemIn.update({ max: parseInt(value) });
                },
                (error) => {
                    this.alert.ajaxError(error);
                },
            );
        },

        triggerError(key) {
            if (key !== '') {
                this.error[key] = true;
            }
        },

        clearError(key) {
            if (key !== '') {
                this.error[key] = false;
            }
        },
    },
};
</script>

<style scoped lang="scss">
.rating-item {
    .description-item,
    .item-weight {
        margin-bottom: map-get($grid-gutter-spacing, 'fifteen');
    }

    .weight-group,
    .max-group {
        margin-bottom: $grid-gutter-width;
        position: relative;

        label {
            flex: 1 0 100%;
        }

        .input-group-text {
            border-top-left-radius: $border-radius-content;
            border-bottom-left-radius: $border-radius-content;
        }
    }

    .max-weight {
        display: flex;
        align-items: center;
        flex-direction: column;
        justify-content: flex-start;

        .max-group ::v-deep,
        .weight-group ::v-deep {
            width: 100%;
            margin-bottom: map-get($grid-gutter-spacing, 'fifteen');

            i {
                &:before {
                    font-weight: $font-weight-normal;
                }
            }
        }

        .weight-error-feedback,
        .max-error-feedback {
            color: $danger;
            font-size: 0.7rem;
            position: relative;
            margin-top: map-get($grid-gutter-spacing, 'eight');
        }
    }
}

.add-option-rating {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    margin-bottom: map-get($grid-gutter-spacing, 'forty-two');
}

.item-weight {
    .input-group {
        label {
            flex: 1 0 100%;
        }

        .input-group-text {
            border-top-left-radius: $border-radius-content;
            border-bottom-left-radius: $border-radius-content;
        }
    }

    i ::v-deep {
        &:before {
            font-weight: $font-weight-normal;
        }
    }

    .weight-error-feedback ::v-deep {
        color: $danger;
        font-size: 0.7rem;
        margin-top: map-get($grid-gutter-spacing, 'eight');
        position: relative;
    }
}

@media (min-width: map-get($grid-breakpoints, 'sm')) {
    .rating-item {
        .max-weight {
            display: flex;
            align-items: center;
            flex-direction: row;
            justify-content: space-between;

            .max-group ::v-deep,
            .weight-group ::v-deep {
                width: calc(50% - 15px);
                margin-bottom: 45px;
            }

            .weight-error-feedback,
            .max-error-feedback {
                position: absolute;
                margin-top: 0;
            }

            .weight-error-feedback,
            .max-error-feedback {
                bottom: -37px;
            }
        }
    }

    .item-weight {
        .item-weight-group {
            max-width: 300px;
            margin-bottom: map-get($grid-gutter-spacing, 'fifteen');
        }
    }
}

@media (min-width: map-get($grid-breakpoints, 'xl')) {
    .rating-item {
        .max-weight {
            justify-content: flex-start;

            .max-group,
            .weight-group {
                max-width: 300px;
            }

            .weight-group {
                margin-right: $grid-gutter-width;
            }

            .max-error-feedback {
                bottom: -21px;
            }
        }

        .item-weight {
            width: 630px;
        }
    }

    .item-weight {
        i ::v-deep {
            &:before {
                font-weight: $font-weight-normal;
            }
        }

        .weight-error-feedback ::v-deep {
            color: $danger;
            font-size: 0.7rem;
            margin-top: map-get($grid-gutter-spacing, 'eight');
            position: absolute;
        }

        .weight-error-feedback {
            bottom: -37px;
        }
    }
}
</style>
